export const getCurrentUrl = () => window?.location?.href;

export const getCurrentUrlWithouQueryParams = () => getCurrentUrl()?.split('?')[0];
